import * as React from 'react';
import hocContext from '@hoc/context';
import { AppContext } from '@store/context'
import classnames from 'classnames';

const Linkedin = require('./linkedin.svg');
const Github = require('./github.svg');
const Stackoverflow = require('./stackoverflow.svg');

import './index.scss';

interface State {
    flex: boolean;
}

interface Props extends AppContext { }

class Follow extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            flex: false,
        }
    }

    public componentDidMount() {
        window.setTimeout(() => {
            this.setState({flex: true});
        }, 1000)
    }

    render(): JSX.Element {
        const { on } = this.props;
        const { flex } = this.state;

        return (
            <div className={classnames('follow slideInRight', {out: !on, flex})}>
                <span>Follow</span>
                <a className="hvr-float" href="https://www.linkedin.com/in/mykola-avasiloi-b7418580/" target="_blank"><img src={Linkedin} /></a>
                <a className="hvr-float" href="https://stackoverflow.com/users/10735964/nick-avasiloy" target="_blank"><img src={Stackoverflow} /></a>
            </div>
        )
    }
}

export default hocContext(Follow);


// WEBPACK FOOTER //
// ./src/components/Home/Follow/index.tsx